















import { Component, Vue } from 'vue-property-decorator';

@Component
export default class NewProgramButton extends Vue {}



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/event/card/newProgramButton/NewProgramButton.vue